<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="cover" id="cvi">
<div class="cover">
<p class="fig"><img alt="" height="750" src="images/nyu-skousen-cover.jpg" width="500"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyu-skousen-0001.vue?eb79a678